import { render } from "./Builder.vue?vue&type=template&id=12b15e7c&ts=true"
import script from "./Builder.vue?vue&type=script&lang=ts"
export * from "./Builder.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kemet/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__